<template>
    <div
        class="history-option"
        :class="activityHistory == historyItem.id ? 'activity' : ''"
        @click="bindItem(historyItem)"
    >
        <template v-if="historyItem.happenTime">
            <el-tooltip placement="left" effect="light" popper-class="event-main">
                <div slot="content">
                    <div class="event-mask">
                        <div class="event-li event-type">{{ historyItem.eventTypeName }}</div>
                        <img class="event-img" :src="historyItem.thumbnail" />
                        <div class="event-li">
                            <span>发现时间：</span>{{ historyItem.createDate || historyItem.happenTime }}
                        </div>
                        <div class="event-li"><span>名称：</span>{{ historyItem.name }}</div>
                        <div class="event-li"><span>地址：</span>{{ historyItem.address }}</div>
                        <el-button
                            type="primary"
                            class="event-btn"
                            plain
                            @click="associatedEvents(historyItem)"
                            >关联事件</el-button
                        >
                    </div>
                </div>
                <img class="history-img" :src="historyItem.thumbnail" />
            </el-tooltip>
        </template>
        <template v-else>
            <img class="history-img" :src="historyItem.thumbnail" />
        </template>
        <div class="history-time">
            <span class="event-type" v-if="type == 'event'">事件</span>
            {{ getHappenTime(historyItem.createDate || historyItem.happenTime) }}
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        historyItem: {
            type: Object,
            default() {
                return {};
            },
        },
        activityHistory: {
            type: String,
            default() {
                return '';
            },
        },
        type: {
            type: String,
            default() {
                return '';
            },
        },
    },
    data() {
        return {};
    },
    watch: {
        historyItem: {
            handler(newVal) {
                console.log('historyItem', newVal);
            },
            deep: true,
            immediate: true,
        },
        activityHistory: {
            handler(newVal) {
                // console.log('activityHistory', newVal);
            },
            deep: true,
            immediate: true,
        },
    },
    computed: {},
    methods: {
        handleClick() {},
        getHappenTime(val) {
            let time = val.split(' ');
            return time[0];
        },
        bindItem(historyItem) {
            // console.log('bindItem', historyItem);
            this.$emit('bindHistoryImg', historyItem.id);
        },
        associatedEvents(obj) {
            this.$emit('associatedEvents', obj);
        },
    },
    created() {},
    mounted() {},
};
</script>

<style lang="scss" scoped>
.history-list {
    background-color: rgba(29, 33, 45, 0.6);
    height: calc(100% - 20px);
    max-height: 500px;
    overflow: hidden;
    .history-option {
        height: 115px;
        width: 120px;
        margin: 10px;
        padding-top: 5px;
        line-height: 1;
        text-align: center;
        background: #e7e7e7;
        border-radius: 4px;
        color: #1d212d;
        .history-img {
            width: 110px;
            height: 90px;
            border-radius: 2px;
        }
        .history-time {
            height: 22px;
            font-size: 12px;
            line-height: 16px;
            text-align: center;
            .event-type {
                display: inline-block;
                padding: 0 4px;
                color: #f5222d;
                background: rgba(245, 34, 45, 0.15);
                border-radius: 2px 2px 2px 2px;
                border: 1px solid rgba(245, 34, 45, 0.5);
                margin-top: 2px;
            }
        }
    }
    .activity {
        color: white;
        background: #2e7df8;
    }
}
.event-main {
    .event-mask {
        width: 250px;
        height: 330px;
        background: white;
        .event-li {
            line-height: 25px;
            height: 25px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            -o-text-overflow: ellipsis;
        }
        .event-type {
            font-weight: 600;
            font-size: 16px;
        }
        .event-btn {
            width: 250px;
        }
        .event-img {
            width: 250px;
        }
        span {
            display: inline-block;
            color: rgba(29, 33, 45, 0.6);
        }
    }
}
</style>
